import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of, Subscription, take } from 'rxjs';
import { GlobalMadlibService } from './../../../shared/services/global-madlib/global-madlib.service';
import { UrlNavigationService } from './../../../shared/services/url-navigation/url-navigation.service';
import { SubLocationFilterSyncService } from './../../../shared/services/op-global-filter/sub-location-filter-sync.service';
import { ENTITY_TYPE } from '../../../shared/typings/types/entity-type.types';

@Injectable()
export class GlobalMadlibResolver implements Resolve<boolean> {
  private globalMadlibService = inject(GlobalMadlibService);
  private subLocationFilterSync = inject(SubLocationFilterSyncService);
  private fetchSub: Subscription | null = null;
  constructor () {}

  // The sub-location sync stays blocking: op-sub-location-scoping needs the selection before the
  // first student-level request. The options fetch is only kicked off — consumers gate on
  // GlobalMadlibService.isLoaded rather than the router waiting on it.
  resolve (route: ActivatedRouteSnapshot): Observable<boolean> {
    this.subLocationFilterSync.start();

    const entityType = UrlNavigationService.getEntityType(route) as ENTITY_TYPE;
    const entityId = UrlNavigationService.getEntityId(route);
    const { globalMadlibState } = route.queryParams;

    // Cancelled on re-entry: the router owned this subscription when the resolver returned it, and
    // dropped it when a navigation was superseded. Now that it is ours, a late response from the
    // entity being left would otherwise overwrite the incoming one's state and release consumers.
    this.fetchSub?.unsubscribe();
    this.fetchSub = this.globalMadlibService
      .initializeState({ entityType, entityId }, globalMadlibState)
      .pipe(take(1))
      .subscribe();

    return of(true);
  }
}
